// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-assest{
    text-align: center;
    margin-top: 30px;
    
}

.wrapper-8 {
    width: 100%;
    height: 100% !important;
    margin: 80px auto;
    max-width: 380px; 
    padding: 40px 30px 30px 30px;
    background-color: #fff;
    border-radius: 15px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    position: relative;
    /* overflow: auto; */
    margin-top: -25px;
}

/* Media query for devices with a width <= 600px (mobile) */
@media (max-width: 600px) {
    .wrapper-8 {
        margin: 10% auto;
        padding: 10px; /* Smaller padding for mobile devices */
        height: 90% !important;
    }
}

/* Media query for devices with a width between 601px and 1024px (iPad) */
@media (min-width: 601px) and (max-width: 1024px) {
    .wrapper-8 {
        margin: 20% auto;
        width: 50%; /* Set maximum width to fit the iPad display */
        height: 70% !important;
    }
}


.text-assest2{
    font-family: 'Poppins' !important;
    font-size: '30px' !important;
}

.judul-assessment{
    font-family: 'Poppins';
    font-size: 25px;
    text-align: center;
    margin-top: 20px;
    font-weight: bold !important;
    color: black;
}

.back-icon-assesst{
    margin-top: -25px;
    margin-right: 500px;
}

.tabel-assesst{
    margin-top: 30px;
    overflow: auto;
    height: 75%;
    width: 100% !important;
}

.back-icon-assessment {
    float: left;
    margin-top: -13%;
    padding-left: 1%;
    font-size: 18px; /* Sesuaikan ukuran font sesuai kebutuhan */
    color: #fff;
}

/* Sesuaikan margin-top pada tampilan desktop */
@media screen and (min-width: 768px) {
    .back-icon-assessment {
        margin-top: 5px; /* Sesuaikan sesuai kebutuhan */
    }
}


.btn-tabel-assesst {
    display: inline-block;
    margin-top: 6% !important;
    margin-left: 53% !important;
    margin-bottom: 10px !important;
    background-color: #176B87;
    color: #fff;
    border: 2px solid rgb(8, 96, 128);
    border-radius: 6px;
    padding: 9px;
    font-size: 0.70em;
    font-family: 'Poppins';
    font-weight: bold;
    cursor: pointer;
    width: 100px !important;
    /* position: fixed; */
}

/* Media query untuk perangkat mobile dengan lebar layar kurang dari 576px */
@media screen and (max-width: 576px) {
    .btn-tabel-assesst {
        margin-left: 0; /* Reset margin-left untuk memberikan tata letak yang sesuai pada perangkat mobile */
        width: 40% !important; /* Lebar penuh pada perangkat mobile */
    }
}

/* Media query for devices with a width between 601px and 1024px (iPad) */
@media (min-width: 601px) and (max-width: 1024px) {
    .btn-tabel-assesst {
        margin-left: 0; /* Reset margin-left untuk memberikan tata letak yang sesuai pada perangkat mobile */
        width: 40% !important; /* Lebar penuh pada perangkat mobile */
        font-size: 10px !important;
    }
}

/* Default styles for larger screens (desktop) */
@media screen and (min-width: 1025px) {
    .btn-tabel-assesst {
        margin-left: 0; /* Reset margin-left untuk memberikan tata letak yang sesuai pada perangkat mobile */
        width: 40% !important; /* Lebar penuh pada perangkat mobile */
        font-size: 10px !important;
    }
}

`, "",{"version":3,"sources":["webpack://./src/components/TotalAssessment/TotalAssessment.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,gBAAgB;;AAEpB;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;IAChB,4BAA4B;IAC5B,sBAAsB;IACtB,mBAAmB;IACnB,wCAAwC;IACxC,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA,2DAA2D;AAC3D;IACI;QACI,gBAAgB;QAChB,aAAa,EAAE,uCAAuC;QACtD,sBAAsB;IAC1B;AACJ;;AAEA,yEAAyE;AACzE;IACI;QACI,gBAAgB;QAChB,UAAU,EAAE,8CAA8C;QAC1D,sBAAsB;IAC1B;AACJ;;;AAGA;IACI,iCAAiC;IACjC,4BAA4B;AAChC;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;IAC5B,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,eAAe,EAAE,2CAA2C;IAC5D,WAAW;AACf;;AAEA,+CAA+C;AAC/C;IACI;QACI,eAAe,EAAE,+BAA+B;IACpD;AACJ;;;AAGA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,2BAA2B;IAC3B,8BAA8B;IAC9B,yBAAyB;IACzB,WAAW;IACX,iCAAiC;IACjC,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;IACtB,iBAAiB;IACjB,eAAe;IACf,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA,4EAA4E;AAC5E;IACI;QACI,cAAc,EAAE,oFAAoF;QACpG,qBAAqB,EAAE,sCAAsC;IACjE;AACJ;;AAEA,yEAAyE;AACzE;IACI;QACI,cAAc,EAAE,oFAAoF;QACpG,qBAAqB,EAAE,sCAAsC;QAC7D,0BAA0B;IAC9B;AACJ;;AAEA,gDAAgD;AAChD;IACI;QACI,cAAc,EAAE,oFAAoF;QACpG,qBAAqB,EAAE,sCAAsC;QAC7D,0BAA0B;IAC9B;AACJ","sourcesContent":[".text-assest{\n    text-align: center;\n    margin-top: 30px;\n    \n}\n\n.wrapper-8 {\n    width: 100%;\n    height: 100% !important;\n    margin: 80px auto;\n    max-width: 380px; \n    padding: 40px 30px 30px 30px;\n    background-color: #fff;\n    border-radius: 15px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    position: relative;\n    /* overflow: auto; */\n    margin-top: -25px;\n}\n\n/* Media query for devices with a width <= 600px (mobile) */\n@media (max-width: 600px) {\n    .wrapper-8 {\n        margin: 10% auto;\n        padding: 10px; /* Smaller padding for mobile devices */\n        height: 90% !important;\n    }\n}\n\n/* Media query for devices with a width between 601px and 1024px (iPad) */\n@media (min-width: 601px) and (max-width: 1024px) {\n    .wrapper-8 {\n        margin: 20% auto;\n        width: 50%; /* Set maximum width to fit the iPad display */\n        height: 70% !important;\n    }\n}\n\n\n.text-assest2{\n    font-family: 'Poppins' !important;\n    font-size: '30px' !important;\n}\n\n.judul-assessment{\n    font-family: 'Poppins';\n    font-size: 25px;\n    text-align: center;\n    margin-top: 20px;\n    font-weight: bold !important;\n    color: black;\n}\n\n.back-icon-assesst{\n    margin-top: -25px;\n    margin-right: 500px;\n}\n\n.tabel-assesst{\n    margin-top: 30px;\n    overflow: auto;\n    height: 75%;\n    width: 100% !important;\n}\n\n.back-icon-assessment {\n    float: left;\n    margin-top: -13%;\n    padding-left: 1%;\n    font-size: 18px; /* Sesuaikan ukuran font sesuai kebutuhan */\n    color: #fff;\n}\n\n/* Sesuaikan margin-top pada tampilan desktop */\n@media screen and (min-width: 768px) {\n    .back-icon-assessment {\n        margin-top: 5px; /* Sesuaikan sesuai kebutuhan */\n    }\n}\n\n\n.btn-tabel-assesst {\n    display: inline-block;\n    margin-top: 6% !important;\n    margin-left: 53% !important;\n    margin-bottom: 10px !important;\n    background-color: #176B87;\n    color: #fff;\n    border: 2px solid rgb(8, 96, 128);\n    border-radius: 6px;\n    padding: 9px;\n    font-size: 0.70em;\n    font-family: 'Poppins';\n    font-weight: bold;\n    cursor: pointer;\n    width: 100px !important;\n    /* position: fixed; */\n}\n\n/* Media query untuk perangkat mobile dengan lebar layar kurang dari 576px */\n@media screen and (max-width: 576px) {\n    .btn-tabel-assesst {\n        margin-left: 0; /* Reset margin-left untuk memberikan tata letak yang sesuai pada perangkat mobile */\n        width: 40% !important; /* Lebar penuh pada perangkat mobile */\n    }\n}\n\n/* Media query for devices with a width between 601px and 1024px (iPad) */\n@media (min-width: 601px) and (max-width: 1024px) {\n    .btn-tabel-assesst {\n        margin-left: 0; /* Reset margin-left untuk memberikan tata letak yang sesuai pada perangkat mobile */\n        width: 40% !important; /* Lebar penuh pada perangkat mobile */\n        font-size: 10px !important;\n    }\n}\n\n/* Default styles for larger screens (desktop) */\n@media screen and (min-width: 1025px) {\n    .btn-tabel-assesst {\n        margin-left: 0; /* Reset margin-left untuk memberikan tata letak yang sesuai pada perangkat mobile */\n        width: 40% !important; /* Lebar penuh pada perangkat mobile */\n        font-size: 10px !important;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
